export const internshipHubTranslations = {
  lv: {
    title: 'Prakšu centrāle',
    leadWithPlace: 'Prakse norit {{organization}} no {{from}} līdz {{to}}.',
    leadWithoutPlace: 'Prakse norit no {{from}} līdz {{to}}.',
    organizationMissing: 'Pašlaik nav piesaistītas prakses vietas',
    contacts: 'Kontakti',
    pdf: 'PDF',
    openDiary: 'Atvērt dienasgrāmatu',
    hoursDone: 'Nostrādātās stundas',
    hoursLeft: 'Atlikušas',
    averageGrade: 'Vidējā atzīme',
    hoursSub: 'No {{planned}} h · {{percent}}%',
    gradeSub: '{{graded}} no {{gradable}} ierakstiem novērtēts',
    gradeNone: 'Nav novērtējuma',
    notices: 'Mani paziņojumi',
    groupCount_one: '{{count}} paziņojumu grupa',
    groupCount_other: '{{count}} paziņojumu grupas',
    markRead: 'Atzīmēt kā izlasītus',
    clear: 'Notīrīt paziņojumus',
    clearTitle: 'Notīrīt paziņojumus',
    clearConfirm: 'Dzēst visus šī konteksta info paziņojumus? Neizlasītie tiks dzēsti arī.',
    empty: 'Nav paziņojumu',
    loading: 'Ielādē…',
    loadError: 'Neizdevās ielādēt paziņojumus',
    statusLoadError: 'Neizdevās ielādēt prakses kopsavilkumu',
    statusLoadErrorHelp: 'Pārbaudi savienojumu un mēģini vēlreiz.',
    contactsHelp:
      'Ja neesi drošs, kam rakstīt — sāc ar prakses vadītāju izglītības iestādē. Viņš koordinē visu tavu praksi.',
    contactGroupWorkplace: 'Prakses vieta',
    contactGroupInstitution: 'Izglītības iestāde',
    contactGroupPast: 'Iepriekšējie kontakti',
    contactFieldKind: {
      workplace: 'Prakses vieta',
      institution: 'Iestāde',
    },
    contactRole: 'Prakses vadītājs',
    contactPurposeLabel: 'Ar viņu runā par',
    contactPurpose: {
      workplace: 'Darba uzdevumiem, grafiku, atzīmēm par saviem ierakstiem',
      institution: 'Aizvērtām dienām, prombūtni, līgumu, prakses termiņu',
    },
    support: 'Tehniskas problēmas',
    supportLabel: 'Ja kaut kas nestrādā',
    supportEmail: 'support@edy365.com',
    noContacts: 'Nav neviena kontakta',
    close: 'Aizvērt',
    pdfPreparing: 'Sagatavo PDF',
    pdfPreparingMessage: 'Dienasgrāmatas PDF tiek ģenerēts. Lūdzu, uzgaidi.',
    pdfError: 'Neizdevās lejupielādēt dienasgrāmatu',
    clearError: 'Neizdevās notīrīt paziņojumus',
    markReadError: 'Neizdevās atzīmēt paziņojumus',
  },
  en: {
    title: 'Internship hub',
    leadWithPlace: 'Your internship at {{organization}} runs from {{from}} to {{to}}.',
    leadWithoutPlace: 'Your internship runs from {{from}} to {{to}}.',
    organizationMissing: 'No internship place is currently assigned',
    contacts: 'Contacts',
    pdf: 'PDF',
    openDiary: 'Open diary',
    hoursDone: 'Worked hours',
    hoursLeft: 'Remaining',
    averageGrade: 'Average grade',
    hoursSub: 'Of {{planned}} h · {{percent}}%',
    gradeSub: '{{graded}} of {{gradable}} records graded',
    gradeNone: 'No evaluation yet',
    notices: 'My notices',
    groupCount_one: '{{count}} notice group',
    groupCount_other: '{{count}} notice groups',
    markRead: 'Mark as read',
    clear: 'Clear notices',
    clearTitle: 'Clear notices',
    clearConfirm: 'Delete all info notices for this context? Unread notices will be deleted too.',
    empty: 'No notices',
    loading: 'Loading…',
    loadError: 'Could not load notices',
    statusLoadError: 'Could not load the internship summary',
    statusLoadErrorHelp: 'Check your connection and try again.',
    contactsHelp:
      'If you are not sure who to contact, start with your educational institution supervisor. They coordinate your internship.',
    contactGroupWorkplace: 'Internship place',
    contactGroupInstitution: 'Educational institution',
    contactGroupPast: 'Previous contacts',
    contactFieldKind: {
      workplace: 'Internship place',
      institution: 'Institution',
    },
    contactRole: 'Internship supervisor',
    contactPurposeLabel: 'Contact them about',
    contactPurpose: {
      workplace: 'Work tasks, schedule, and feedback on your Diary Entries.',
      institution: 'Reopened days, absence, agreements, and your internship dates.',
    },
    support: 'Technical problems',
    supportLabel: 'If something does not work',
    supportEmail: 'support@edy365.com',
    noContacts: 'No contacts found',
    close: 'Close',
    pdfPreparing: 'Preparing PDF',
    pdfPreparingMessage: 'Your diary PDF is being generated. Please wait.',
    pdfError: 'Could not download the diary',
    clearError: 'Could not clear notices',
    markReadError: 'Could not mark notices as read',
  },
} as const
